import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { t } from '@lingui/macro';
import FooterWrapper from './styled';
import AssignButton from '../assign-button';
import UnassignButton from '../unassign-button';
import useAssignmentsToAssign from '../../helpers/hooks/use-assignment-to-assign';
import useAssignmentsToUnassign from '../../helpers/hooks/use-assignment-to-unassign';
import { useAssignmentFlowStart } from '../../analytics';
import { getDueDateISOString } from '../../helpers/utils';

function Footer(props) {
  const { i18n } = props;
  const actionInProgress = useSelector(
    (state) => state.CourseAssignReducer.actionInProgress
  );
  const datePreference = useSelector(
    (state) => state.CourseAssignReducer?.datePreference || []
  );

  // Collects selected unassigned activities and its taskType from state
  const assignmentsToAssign = useAssignmentsToAssign();
  useAssignmentFlowStart(
    assignmentsToAssign,
    getDueDateISOString(datePreference[1])
  );

  // Collects selected assigned activities and its taskType from state
  const assignmentsToUnassign = useAssignmentsToUnassign();

  const courseID = useSelector(
    (state) => state.CourseAssignReducer.activeCourseID
  );
  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );
  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);

  const count = assignmentsToAssign.length + assignmentsToUnassign.length || 0;

  return (
    <>
      <FooterWrapper>
        <div data-name="collapsed" className="buttonPanel collapsed">
          {count}{' '}
          {count > 1
            ? `${i18n._(t('footer.cellsSelected')`cells selected`)}`
            : `${i18n._(t('footer.cellSelected')`cell selected`)}`}
        </div>
        <div data-name="expanded" className="buttonPanel expanded">
          <UnassignButton
            i18n={i18n}
            actionInProgress={actionInProgress}
            assignmentsToUnassign={assignmentsToUnassign}
            groupId={groupId}
            classroomId={classroomId}
          />
          <AssignButton
            i18n={i18n}
            actionInProgress={actionInProgress}
            assignmentsToAssign={assignmentsToAssign}
            courseId={courseID}
            groupId={groupId}
            classroomId={classroomId}
            startDatePreference={datePreference[0]}
            dueDatePreference={datePreference[1]}
          />
        </div>
      </FooterWrapper>
    </>
  );
}

Footer.propTypes = {
  i18n: PropTypes.object
};

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/index.js